module.exports = __webpack_public_path__ + "img/notion.3c036dc3.jpg";